import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axios } from "../../utils/axios"; // Use axios for API calls

// Async thunk to fetch search results based on location and dates
export const getTripResults = createAsyncThunk(
  "trips/view-tripResults",
  async ({ tripId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND + `view-trip/viewtrip?tripid=${tripId}`
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch search results"
      );
    }
  }
);
export const UpdateTripResults = createAsyncThunk(
  "trips/update-tripResults",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND + "view-trip/updatetrip",
        data
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch search results"
      );
    }
  }
);

// Initial state
const initialState = {
  tripResults: null,
  error: null,
  loading: false,
};

export const trips = createSlice({
  name: "trips",
  initialState,
  reducers: {
    setTripResults: (state, action) => {
      state.tripResults = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle fetch search results cases
      .addCase(getTripResults.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTripResults.fulfilled, (state, action) => {
        state.loading = false;
        state.tripResults = action.payload;
      })
      .addCase(getTripResults.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(UpdateTripResults.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(UpdateTripResults.fulfilled, (state, action) => {
        state.loading = false;
        state.tripResults = action.payload;
      })
      .addCase(UpdateTripResults.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { setTripResults } = trips.actions;
export default trips.reducer;
